import React, { useState, useEffect } from "react";
import { colors } from "../../../themes/Colors";

const LoadingPopUp = ({ display, width, color }) => {
  const [animationStart, setAnimationStart] = useState(false);
  useEffect(() => {
    setAnimationStart(true);
    setTimeout(() => {
      setAnimationStart(false);
    }, 800);
  }, [display]);
  useEffect(() => {
    if (!animationStart) {
      setTimeout(() => {
        setAnimationStart(true);
      }, 800);
    } else {
      setTimeout(() => {
        setAnimationStart(false);
      }, 800);
    }
  }, [animationStart]);
  return (
    <div
      style={{
        position: "absolute",
        width: display ? " 100%" : 0,
        height: display ? " 100%" : 0,
        top: 0,

        transition: "all 0.8s",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor:
          color === "orange" ? colors.primaryOrange50 : colors.primaryBlue50,
        flexDirection: "column",
        opacity: display ? 1 : 0,
        zIndex: 100000000,
      }}
    >
      <div>
        <img
          src={
            color === "orange"
              ? require("../../../images/base-logo-desgns/driverfriendIconOrange.png")
              : require("../../../images/base-logo-desgns/driverfrinedIcon1.png")
          }
          className="App-logo"
          alt="logo"
          style={{
            // height: 100,
            height:
              width > 899
                ? animationStart
                  ? 200
                  : 40
                : animationStart
                ? 140
                : 20,
            transition: "all 0.8s",
            opacity: 0.9,
          }}
        />
      </div>
      {/* <div
        style={{
          height: 250,
          width: 250,
          borderRadius: 300,
          transition: "all 0.6s",
          WebkitBoxShadow: "-2px 5px 20px 1px #00000080",
          opacity: display ? 1 : 0,
          backgroundColor: colors.white,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          alt={"Logo"}
          src={require("../../../images/logo/logoWhiteBAckGround.png")}
          style={{ width: 250 }}
        />
      </div> */}
    </div>
  );
};
export default LoadingPopUp;
